import { useContext } from 'react';

import { HabitFormContext } from './habit-form-context';

export const useOpenCreateHabitDialog = () => {
  const { onCreateHabit } = useContext(HabitFormContext);

  return onCreateHabit;
};
